import React from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <section className="bg-white">
      <div className="mx-auto w-full min-h-screen flex justify-center items-center">
        <div className="mx-auto max-w-screen-sm text-center">
          <h1 className="mb-4 tracking-tight font-extrabold text-9xl text-custom-blue-600">
            404!
          </h1>
          <p className="mb-4 text-3xl tracking-tight font-bold text-gray-900 md:text-4xl">
            Sorry, we can't find that page.
          </p>
          <div className="mt-16">
            <Link
              to="/"
              className="px-5 py-6 bg-custom-blue-600 text-black rounded-lg uppercase font-semibold"
            >
              Back to Homepage
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NotFound;
